import React, {Component} from 'react';
import {Col, Form, FormGroup, ControlLabel, FormControl, Checkbox} from "react-bootstrap";
import {TopButtonCancel, TopButtonSave} from "../../../../../componentsTopsa/buttons/TopButtons";
import {TopSelect} from "../../../../../componentsTopsa/selects/TopSelects";
import Validator from "../../../../../utilities/Validator";
import ValidatorMessages from "../../../../../shared/validatorMessages/ValidatorMessages";

export default class TrasyForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            kodTrasy: '',
            miejscowosc_od: null,
            miejscowosc_do: null,
            nazwa_trasy: '',
            validatorMessages: [],
            status: true,
            stawka: '',
            trasaOdwrotna:null,
            czastrasy:null,
            dystans:null
        };
        this.onClickZapisz = this.onClickZapisz.bind(this);
        this.onChangeKodTrasy = this.onChangeKodTrasy.bind(this);
        this.onChangeMiejscowoscOd = this.onChangeMiejscowoscOd.bind(this);
        this.onChangeMiejscowoscDo = this.onChangeMiejscowoscDo.bind(this);
        this.onChangeNazwaTrasy = this.onChangeNazwaTrasy.bind(this);
        this.onChangeStawka = this.onChangeStawka.bind(this);
        this.onChangeTrasaOdwrotna = this.onChangeTrasaOdwrotna.bind(this);
    }

    componentDidMount() {
        if (Boolean(this.props.trasa)) {
            this.setState({
                kodTrasy: this.props.trasa.kodTrasy,
                nazwa_trasy: this.props.trasa.nazTr,
                miejscowosc_od: this.props.miejscowosci.find(m => m.nazMi === this.props.trasa.nazMiOd),
                miejscowosc_do: this.props.miejscowosci.find(m => m.nazMi === this.props.trasa.nazMiDo),
                status: Boolean(this.props.trasa.status == 0),
                stawka: this.props.trasa.stawka,
                trasaOdwrotna: Boolean(this.props.trasa.idTrPow)? this.props.trasy.find(t=>t.idTr===this.props.trasa.idTrPow):null,
                czastrasy:this.props.trasa.czasTr,
                dystans:this.props.trasa.dystans
            })
            document.getElementById('inputStawka').value = this.props.trasa.stawka;
        }
    }

    componentWillReceiveProps(nextprops) {
        if (nextprops.trasa) {
            this.setState({
                kodTrasy: nextprops.trasa.kodTrasy,
                nazwa_trasy: nextprops.trasa.nazTr,
                miejscowosc_od: this.props.miejscowosci.find(m => m.nazMi === nextprops.trasa.nazMiOd),
                miejscowosc_do: this.props.miejscowosci.find(m => m.nazMi === nextprops.trasa.nazMiDo),
                status: Boolean(this.props.trasa.status == 0),
                stawka:nextprops.trasa.stawka,
                trasaOdwrotna: Boolean(nextprops.trasa.idTrPow)? this.props.trasy.find(t=>t.idTr===nextprops.trasa.idTrPow):null,
                czastrasy:nextprops.trasa.czasTr,
                dystans:nextprops.trasa.dystans
            })

            document.getElementById('InputNazwaTrasy').value = nextprops.trasa.nazTr;
            document.getElementById('InputKodTrasy').value = nextprops.trasa.kodTrasy;
            document.getElementById('inputStawka').value = nextprops.trasa.stawka;
        }
    }

    dodajDoValidatorMessages(msg) {
        let arr = this.state.validatorMessages;
        arr.push(msg)
        this.setState({validatorMessages: arr})
    }

    onClickZapisz() {

        let poprawne = true;
        this.state.validatorMessages = [];

        if (this.state.nazwa_trasy === '-' || this.state.nazwa_trasy.length <= 0) {
            poprawne = false;
            this.dodajDoValidatorMessages('Nazwa trasy jest niepoprawna')
        }

        if (!Boolean(this.state.miejscowosc_od)) {
            poprawne = false;
            this.dodajDoValidatorMessages('Miejscowość startowa nie jest wybrana')
        }

        if (!Boolean(this.state.miejscowosc_do)) {
            poprawne = false;
            this.dodajDoValidatorMessages('Miejscowość docelowa nie jest wybrana')
        }

        if (!Boolean(this.state.stawka)) {
            poprawne = false;
            this.dodajDoValidatorMessages('Należy uzupełnić stawkę')
        }

        if (this.state.kodTrasy.length <= 0) {
            poprawne = false;
            this.dodajDoValidatorMessages('Kod trasy nie jest uzupełniony')
        }

        if (poprawne) {

            let status = 0;

            if (!Boolean(this.state.status)) status = -1;
            else status = 0;

            this.setState({validatorMessages: []})
            let data = {
                "kodTrasy": this.state.kodTrasy,
                "nazMiDo": this.state.miejscowosc_do.nazMi,
                "nazMiOd": this.state.miejscowosc_od.nazMi,
                "nazTr": this.state.nazwa_trasy,
                "status": status,
                "stawka": (this.state.stawka).toString().replace(',','.'),
                "idTrPow": Boolean(this.state.trasaOdwrotna)? this.state.trasaOdwrotna.idTr : null,
                "dystans":this.state.dystans,
                "czasTr":this.state.czastrasy
            }

            if (Boolean(this.props.trasa)) {
                this.props.handleClickZapisz(data, true)
            }
            else {
                this.props.handleClickZapisz(data, false)
            }
        }
    }

    onChangeKodTrasy(e) {
        if (Validator.validateLenghtWithClearing(e.target.value, 5, 'InputKodTrasy', this.state.kodTrasy)) {
            this.setState({kodTrasy: e.target.value})
        }
    }

    onChangeMiejscowoscOd(e) {
        this.setState({miejscowosc_od: e})
        this.generujNazweTrasy(e.nazMi, (Boolean(this.state.miejscowosc_do)) ? this.state.miejscowosc_do.nazMi : '')
    }

    onChangeMiejscowoscDo(e) {
        this.setState({miejscowosc_do: e})
        this.generujNazweTrasy((Boolean(this.state.miejscowosc_od)) ? this.state.miejscowosc_od.nazMi : '', e.nazMi)
    }

    onChangeNazwaTrasy(e) {
        if (Validator.validateLenghtWithClearing(e.target.value, 60, 'InputNazwaTrasy', this.state.nazwa_trasy)) {
            this.setState({nazwa_trasy: e.target.value})
        }
    }

    onChangeStawka(e) {
        this.setState({stawka: e.target.value})
    }

    generujNazweTrasy(start, cel) {
        document.getElementById('InputNazwaTrasy').value = start + '-' + cel;
        this.setState({nazwa_trasy: start + '-' + cel})
    }

    onChangeTrasaOdwrotna(e){
        this.setState({
            trasaOdwrotna:e
        })
    }

    render() {

        return (
            <div>
                <fieldset>
                    <div className={'fieldset-label'}>{Boolean(this.props.trasa) ? 'Edycja trasy' : 'Nowa trasa'}</div>
                    <Form horizontal={true}>
                        <FormGroup style={{marginBottom: 0}}>
                            <Col xs={12} sm={6} md={6} lg={2}>
                                <ControlLabel>
                                    Kod trasy <span className={'req'}>*</span> <span style={{fontSize:'12px', color:'grey',fontStyle:'italic', fontWeight:'normal'}}>{this.state.kodTrasy.length}/5 znaków</span>
                                </ControlLabel>
                                <FormControl onChange={this.onChangeKodTrasy}
                                             defaultValue={Boolean(this.props.trasa) ? this.props.trasa.kodTrasy : ''}
                                             id={'InputKodTrasy'}/>
                            </Col>
                            <Col xs={12} sm={6} md={6} lg={2}>
                                <ControlLabel>
                                    Miejscowość od <span className={'req'}>*</span>
                                </ControlLabel>
                                <TopSelect onChange={this.onChangeMiejscowoscOd}
                                           value={this.state.miejscowosc_od}
                                           options={this.props.miejscowosci}
                                           labelKey={'nazMi'}
                                           valueKey={'idMi'}/>
                            </Col>
                            <Col xs={12} sm={6} md={6} lg={2}>
                                <ControlLabel>
                                    Miejscowość do <span className={'req'}>*</span>
                                </ControlLabel>
                                <TopSelect onChange={this.onChangeMiejscowoscDo}
                                           value={this.state.miejscowosc_do}
                                           options={this.props.miejscowosci}
                                           labelKey={'nazMi'}
                                           valueKey={'idMi'}/>
                            </Col>
                            <Col xs={12} sm={6} md={6} lg={3}>
                                <ControlLabel>
                                    Nazwa trasy <span className={'req'}>*</span> <span style={{fontSize:'12px', color:'grey',fontStyle:'italic', fontWeight:'normal'}}>{this.state.nazwa_trasy.length}/60 znaków</span>
                                </ControlLabel>
                                <FormControl onChange={this.onChangeNazwaTrasy} defaultValue={Boolean(this.props.trasa) ? this.props.trasa.nazTr : ''}
                                             id={'InputNazwaTrasy'}/>
                            </Col>
                            <Col xs={12} sm={12} md={12} lg={3}>
                                <div className={'add-label-margin'}></div>
                                <TopButtonCancel onClick={() => {
                                    this.props.handleClickAnuluj()
                                }} text={'Anuluj'}/>
                                <TopButtonSave onClick={this.onClickZapisz} text={'Zapisz'}/>
                            </Col>
                        </FormGroup>
                        <FormGroup>
                            <Col xs={4} lg={2}>
                                <ControlLabel>
                                    Stawka <span className={'req'}>*</span>
                                </ControlLabel>
                                <FormControl onChange={this.onChangeStawka}
                                             type={'number'}
                                             id={'inputStawka'}
                                />
                            </Col>
                            {
                                Boolean(this.props.trasa)?
                                    <Col xs={4} lg={3}>
                                        <ControlLabel>
                                            Trasa odwrotna
                                        </ControlLabel>
                                        <TopSelect onChange={this.onChangeTrasaOdwrotna}
                                                   value={this.state.trasaOdwrotna}
                                                   options={this.props.trasy}
                                                   valueKey={'idTr'}
                                                   labelKey={'nazTr'}
                                        />
                                    </Col>
                                    :
                                    ''
                            }

                            <Col xs={8} lg={5}>
                                <div className={'add-label-margin'}></div>
                                <Checkbox checked={this.state.status} onClick={() => {
                                    this.setState({status: !this.state.status})
                                }}>Czy dostępny?</Checkbox>
                            </Col>
                        </FormGroup>
                        <FormGroup>
                            <ValidatorMessages messages={this.state.validatorMessages}/>
                        </FormGroup>
                    </Form>
                </fieldset>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/trasyConfig/trasy/components/TrasyForm.js